import api from './api';

export const qcommerceApi = {
  listPlatforms: () => api.get('/qc/platforms'),
  listHubStores: () => api.get('/qc/hub/stores'),
  getHubAdsReport: (params) => api.get('/qc/hub/reports/ads', { params }),
  listBrands: (platform) => api.get(`/qc/${platform}/brands`),
  createBrand: (platform, body) => api.post(`/qc/${platform}/brands`, body),
  getBrand: (platform, brandId) => api.get(`/qc/${platform}/brands/${brandId}`),
  listRuns: (platform, params = {}) => api.get(`/qc/${platform}/runs`, { params }),
  getRun: (platform, brandId, runId) => api.get(`/qc/${platform}/brands/${brandId}/runs/${runId}`),
  getDataHealth: (platform, brandId) => api.get(`/qc/${platform}/brands/${brandId}/data-health`),
  getAdsReport: (platform, brandId, params) => api.get(`/qc/${platform}/brands/${brandId}/reports/ads`, { params }),
  getSettings: (platform, brandId) => api.get(`/qc/${platform}/brands/${brandId}/settings`),
  patchSettings: (platform, brandId, body) => api.patch(`/qc/${platform}/brands/${brandId}/settings`, body),
  seedDemo: (platform) => api.post(`/qc/${platform}/demo/seed`, {}, { timeout: 180000 }),
  seedDemoForBrand: (platform, brandId) =>
    api.post(`/qc/${platform}/brands/${brandId}/demo/seed`, {}, { timeout: 180000 }),
  getSalesReport: (platform, brandId, params) => api.get(`/qc/${platform}/brands/${brandId}/reports/sales`, { params }),
  getPeriodsReport: (platform, brandId) => api.get(`/qc/${platform}/brands/${brandId}/reports/periods`),
  getExploreLayout: (platform, brandId) => api.get(`/qc/${platform}/brands/${brandId}/explore`),
  patchExploreLayout: (platform, brandId, body) => api.patch(`/qc/${platform}/brands/${brandId}/explore`, body),

  getMyAccess: () => api.get('/qc/me/access'),
  listMemberAccess: () => api.get('/qc/admin/member-access'),
  upsertMemberAccess: (userId, body) => api.put(`/qc/admin/member-access/${userId}`, body),

  listPortalAccounts: () => api.get('/qc/admin/portal-accounts'),
  createPortalAccount: (body) => api.post('/qc/admin/portal-accounts', body),
  updatePortalAccount: (accountId, body) => api.put(`/qc/admin/portal-accounts/${accountId}`, body),
  getPortalAccountOtpInbox: (accountId) =>
    api.get(`/qc/admin/portal-accounts/${accountId}/otp-inbox`),
  getOtpInboxSettings: () => api.get('/qc/admin/otp-inbox/settings'),
  portalAuthLogin: (body) => api.post('/qc/portal-auth/login', body),
  portalAuthVerifyOtp: (body) => api.post('/qc/portal-auth/verify-otp', body),
  getPortalAuthSession: (platform, brandId) =>
    api.get('/qc/portal-auth/session', { params: { platform, brandId } }),

  zeptoToolBase: (brandId) => `/qc/zepto/brands/${brandId}/zepto-tool`,
  zeptoReportTypes: (brandId) => api.get(`/qc/zepto/brands/${brandId}/zepto-tool/report-types`),
  zeptoUploadHistory: (brandId) => api.get(`/qc/zepto/brands/${brandId}/zepto-tool/uploads`),
  zeptoPreviewUpload: (brandId, reportType, file) => {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('reportType', reportType);
    return api.post(`/qc/zepto/brands/${brandId}/zepto-tool/uploads/preview`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 120000,
    });
  },
  zeptoImportUpload: (brandId, { reportType, file, tempId, fileName }) => {
    const fd = new FormData();
    fd.append('reportType', reportType);
    if (file) fd.append('file', file);
    if (tempId) fd.append('tempId', tempId);
    if (fileName) fd.append('fileName', fileName);
    return api.post(`/qc/zepto/brands/${brandId}/zepto-tool/uploads`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 300000,
    });
  },
  zeptoWorkspaceDashboard: (brandId, params) =>
    api.get(`/qc/zepto/brands/${brandId}/zepto-tool/workspace/dashboard`, { params }),
  zeptoWorkspaceSales: (brandId, params) =>
    api.get(`/qc/zepto/brands/${brandId}/zepto-tool/workspace/sales`, { params }),
  zeptoWorkspacePo: (brandId, params) =>
    api.get(`/qc/zepto/brands/${brandId}/zepto-tool/workspace/po`, { params }),
  zeptoWorkspaceGrn: (brandId, params) =>
    api.get(`/qc/zepto/brands/${brandId}/zepto-tool/workspace/grn`, { params }),
  zeptoWorkspaceInventory: (brandId) =>
    api.get(`/qc/zepto/brands/${brandId}/zepto-tool/workspace/inventory`),
  zeptoWorkspaceCatalog: (brandId) =>
    api.get(`/qc/zepto/brands/${brandId}/zepto-tool/workspace/catalog`),
  zeptoAutoSyncConfig: (brandId) =>
    api.get(`/qc/zepto/brands/${brandId}/zepto-tool/auto-sync/config`),
  zeptoAutoSyncJobs: (brandId) =>
    api.get(`/qc/zepto/brands/${brandId}/zepto-tool/auto-sync/jobs`),
  zeptoAutoSyncJob: (brandId, jobId) =>
    api.get(`/qc/zepto/brands/${brandId}/zepto-tool/auto-sync/jobs/${jobId}`),
  zeptoAutoSyncStart: (brandId, body) =>
    api.post(`/qc/zepto/brands/${brandId}/zepto-tool/auto-sync/start`, body),
  zeptoAutoSyncOtp: (brandId, jobId, otp) =>
    api.post(`/qc/zepto/brands/${brandId}/zepto-tool/auto-sync/jobs/${jobId}/otp`, { otp }),
  zeptoAutoSyncCancel: (brandId, jobId) =>
    api.post(`/qc/zepto/brands/${brandId}/zepto-tool/auto-sync/jobs/${jobId}/cancel`),
};
